"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypePriceFeeToString = void 0;
const transformVehicleTypeToString_1 = require("./transformVehicleTypeToString");
function transformVehicleTypePriceFeeToString(displayVehicleType, vehicleTypePriceFee, additionalPriceAndFeesAmount) {
    return `${displayVehicleType
        ? `${(0, transformVehicleTypeToString_1.transformVehicleTypeToString)(vehicleTypePriceFee.vehicleType)}:\xa0`
        : ""}\u20AC${vehicleTypePriceFee.price +
        vehicleTypePriceFee.fee +
        additionalPriceAndFeesAmount}`;
}
exports.transformVehicleTypePriceFeeToString = transformVehicleTypePriceFeeToString;
//# sourceMappingURL=transformVehicleTypePriceFeeToString.js.map